import { useState, createContext } from 'react';
import isCustomerRole from '../helpers/role/isCustomerRole';
import { navigateTo } from '../router/navigation';
import { getStoredUser, clearUserSession } from '../helpers/auth/storage';

// create context
const Context = createContext();

// create provider
const ProviderContext = ({ children }) => {
  const storedUser = getStoredUser();
  const storedRole = storedUser.role || '';
  const storedLang = localStorage.getItem('lang');
  const initialLang = storedLang || (isCustomerRole(storedRole) ? 'EN' : 'ES');

  const initialState = {
    lang: initialLang,
    login: false,
    user: {
      id: storedUser.id,
      username: storedUser.username,
      role: storedUser.role,
      token: storedUser.token,
      scopes: storedUser.scopes,
    },
    loading: false,
    checkingToken: false,
    noToken: false,
    modal: {
      title: '',
      open: false,
      children: '',
      onConfirm: () => {},
      textConfirm: null,
      noActions: false,
    },
  };

  const responseInitialState = {
    title: '',
    message: '',
    typeAlert: '',
    status: false,
  };

  const [state, setState] = useState(initialState);
  const [response, setResponse] = useState(responseInitialState);

  const [previousSearch, setPreviousSearch] = useState({
    filter: {
      keyword: '',
      order: '',
      cliente: '',
      agrupar: '',
    },
    page: 1,
  });

  const handleLogin = (user) => {
    const lang = isCustomerRole(user?.role) ? 'EN' : 'ES';
    localStorage.setItem('lang', lang);
    setState((prev) => ({
      ...prev,
      lang,
      login: true,
      user: {
        id: user.id,
        username: user.username,
        role: user.role,
        token: user.token,
        scopes: user.scopes,
      },
    }));
  };

  const handleLogout = () => {
    clearUserSession();
    setTimeout(() => {
      setInitialValues();
    }, 1000);
  };

  const setInitialValues = () => {
    setState((prev) => ({
      ...prev,
      lang: 'ES',
      login: false,
      user: {
        id: 0,
        username: '',
        role: '',
        token: '',
        scopes: [],
      },
      loading: false,
      checkingToken: false,
      noToken: true,
      modal: {
        title: '',
        open: false,
        children: '',
        onConfirm: () => {},
        textConfirm: null,
        noActions: false,
      },
    }));
  };

  const forceLogout = () => {
    clearUserSession();
    setInitialValues();
    navigateTo('/login', { replace: true });
  };

  const value = {
    state,
    setState,
    handleLogin,
    handleLogout,
    forceLogout,
    response,
    setResponse,
    responseInitialState,
    previousSearch,
    setPreviousSearch,
  };

  return <Context.Provider value={value}>{children}</Context.Provider>;
};
// create consumer
const Consumer = Context.Consumer;
// export context, provider and consumer
export { Context, ProviderContext, Consumer };
